module.exports = __webpack_public_path__ + "static/media/google-maps.18b1fee2.svg";